import { IoPrint, IoSearch } from "react-icons/io5"
import { Template } from "../../Components/Template/template"
import { Funcoes } from "../../Utils/Funcoes"
import {
    AlertType, ItensVendas, classBorderLabelDark, classBt, classBtSemDuration, classDivBackground, classDivBody, classDivTitulo, classInput, classInputDark,
    classLabel, classLabelDark, classbtCeuAzul, classbtCinzaClaro, classbtColunasAzul
} from "../../Utils/Types"
import { TbReport } from "react-icons/tb"
import { useCallback, useEffect, useState } from "react"
import moment from "moment"
import { VendasService } from "./vendasService"
import { GridRelPeriodoItens } from "../../Components/GridProducts/GridRelatorioItensPeriodo"
import { ReportItensPeriodoPDF } from "./pdf/report-itens-periodo-pdf"
import { FeedbackMessage } from "../../Components/FeedbackMessage/feedback-message"
import { DataSearch } from "../../Components/SearchBox/SearchBox"
import { UserService } from "../Users/User.service"
import { IoIosArrowDropdownCircle } from "react-icons/io"
import { AiOutlineClear } from "react-icons/ai"

export const RelatorioItensVendas = () => {

    let dateI = moment()
        .utcOffset('-03:00')
        .format('YYYY-MM-DD')

    let dateF = moment()
        .utcOffset('-03:00')
        .add(30, 'days')
        .format('YYYY-MM-DD')

    // ---------- ATRIBUTOS FEEDBACK --------------------------------------------------
    const [visible, setVisible] = useState(false)
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")

    // ---------- ATRIBUTOS FILTRO ----------------------------------------------------
    const [datai, setDatai] = useState(dateI)
    const [dataf, setDataf] = useState(dateF)

    const [relatorio, setRelatorio] = useState<ItensVendas[]>([])

    // FILTRO VENDEDOR ----------------------------------------------------------------
    const [visibleListaUsuario, setVisibleListaUsuario] = useState(false)
    const [usuariosList, setUsuariosList] = useState<DataSearch[]>([])
    const [usuarios, setUsuarios] = useState<DataSearch[]>([])
    const [nomeVendedor, setNomeVendedor] = useState("")
    const [linhaSelecionadaUsuario, setLinhaSelecionadaUsuario] = useState<number>(-1)
    //const [nomeVendedorCopy, setNomeVendedorCopy] = useState("")
    //const [idVendedor, setIdVendedor] = useState(0)

    // ---------- ATRIBUTOS DADOS VENDAS ----------------------------------------------
    const [valorBruto, setValorBruto] = useState(0)
    const [valorLiquido, setValorLiquido] = useState(0)
    const [valorDesconto, setValorDesconto] = useState(0)
    const [totalRegistro, setTotalRegistro] = useState(0)

    // ---------- ATRIBUTOS LOADING ---------------------------------------------------
    const [loadingPesq, setLoadingPesq] = useState(false)

    // ---------- ATRIBUTOS GRID ------------------------------------------------------
    const [selectedItems, setSelectedItems] = useState<any[]>([]);
    const [selectedItemsID, setSelectedItemsID] = useState<any[]>([]);

    // ------------------------------------------------------------------ ATALHOS E USEEFFECT -----------------------------------------------------------------------
    const handleKeyPressEnter = async (e: any) => {

        if ((e.code === "Enter" || e.code === "NumpadEnter") && !loading && !loadingPesq) {

            if (!visibleListaUsuario) {

                await handleFilterClick()

            } else {

                buscarUsuario()
            }
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handleKeyPressEnter)

        return () => {
            document.removeEventListener('keydown', handleKeyPressEnter)
        }
    }, [datai, dataf, relatorio, loading, visibleListaUsuario, nomeVendedor, loadingPesq])


    // ------------------------------------------------------------------ FUNÇOES DE API ----------------------------------------------------------------------------
    const buscarUsuario = async () => {

        setLoadingPesq(true)
        setVisible(false)

        try {

            const resp = await UserService.UsuarioList(nomeVendedor)

            if (!resp.error) {

                let newUsuariosList: DataSearch[] = resp.data.map((item: { id: number; nome: string }) => { return { id: item.id, description: item.nome } })
                setUsuarios(newUsuariosList)

            }

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage('Não foi possível buscar os usuarios')

        } finally {
            setLoadingPesq(false)

            const timer = setTimeout(() => {
                const inputElement = document.getElementById("pesquisaUsua")
                inputElement?.focus()
                clearTimeout(timer)
            }, 0)

        }
    }

    const handleFilterClick = async () => {

        setVisible(false)
        setLoading(true)
        setRelatorio([])
        setValorBruto(0)
        setValorLiquido(0)
        setValorDesconto(0)
        setTotalRegistro(0)
        fecharLista()

        try {

            const resp = await VendasService.VendaItensPorPeriodo(datai, dataf, selectedItemsID, 'id')

            if (resp.error) {

                setVisible(true)
                setMessageType('DANGER')
                setMessage(resp.msg || '')

            } else {
                let dadosItens = []

                for (let i = 0; i < resp.data.length; i++) {

                    for (let j = 0; j < resp.data[i].itens.length; j++) {
                        dadosItens.push(resp.data[i].itens[j])
                    }
                }

                setRelatorio(dadosItens)

                setValorBruto(resp.valor_total_bruto || 0)
                setValorLiquido(resp.valor_total_liquido || 0)
                setValorDesconto(resp.valor_total_desconto || 0)
                setTotalRegistro(resp.quantidade_registro || 0)
            }

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage('Não foi possível buscar as vendas')

        } finally {
            setLoading(false)

            const timer = setTimeout(() => {
                InputFocus()
                clearTimeout(timer)
            }, 0)
        }
    }

    const limparCamposFiltro = () => {
        setDatai(dateI)
        setDataf(dateF)
        setUsuarios([])
        setUsuariosList([])
        setNomeVendedor("")
        setVisibleListaUsuario(false)
        setSelectedItems([])
        setSelectedItemsID([])
    }

    // ------------------------------------------------------------------ INPUTS -------------------------------------------------------------------------------------
    const handleChangeDtInicio = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDatai(e.target.value)
    }

    const handleChangeDtFim = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataf(e.target.value)
    }

    const InputFocus = () => {
        const inputElement = document.getElementById("data-inicial")
        inputElement?.focus()
    }

    const handleCloseMessage = () => {
        setVisible(false)
    }

    //------------------------------------------------------------------- USUARIO -------------------------------------------------------------------------------------
    const handleChangeNomeVendedor = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNomeVendedor(e.target.value)
    }

    const usuarioFilter = async () => {
        //buscarUsuario()
    }

    const handleSetProdClick = (item: any, index: number) => {
        //setIdVendedor(item.id)
        //setNomeVendedor(item.descricao)
        //setNomeVendedorCopy(item.descricao)
        //setUsuarios([])
        //setLinhaSelecionadaUsuario(-1)
        //console.log("item: ", item)
        //setSelectedItems(item.descricao)
        //setSelectedItems(item.id)
        //setVisibleListaUsuario(false)
    }

    const handleSetProdMove = (item: any, index: number) => {
        //setIdVendedor(item.id)
        //setNomeVendedorCopy(item.descricao)
        //setLinhaSelecionadaUsuario(index)
    }

    const handleCheckBoxClick = useCallback((item: any) => {
        const toggleSelection = (prev: any[], value: any) =>
            prev.includes(value) ? prev.filter(i => i !== value) : [...prev, value];


        setUsuariosList(prev => toggleSelection(prev, item))
        setSelectedItems(prev => toggleSelection(prev, item.description));
        setSelectedItemsID(prev => toggleSelection(prev, item.id));
    }, []);

    const abrirLista = () => {
        setVisibleListaUsuario(!visibleListaUsuario)

        const timer = setTimeout(() => {
            setNomeVendedor("")
            //setNomeVendedorCopy("")
            setLinhaSelecionadaUsuario(-1)
            setUsuarios(usuariosList)
            const inputElement = document.getElementById("pesquisaUsua")
            inputElement?.focus()
            clearTimeout(timer)
        }, 0)

    }

    const fecharLista = () => {
        setVisibleListaUsuario(false)
        setLinhaSelecionadaUsuario(-1)
        setUsuarios([])
    }

    /*
    useEffect(() => {

        setUsuarios([])

        if (nomeVendedorCopy === '') {

            const delayDebounceFn = setTimeout(() => {

                if (nomeVendedor && nomeVendedor.length > 0) {

                    usuarioFilter()  // Chama a função após 500 segundos de inatividade
                } else {

                    setUsuarios([])
                }
            }, 500) // 500 segundos

            setIdVendedor(0)

            return () => clearTimeout(delayDebounceFn)

        } else {

            setNomeVendedorCopy("")
            setLinhaSelecionadaUsuario(-1)

        }

    }, [nomeVendedor])
    */

    /*
    useEffect(() => {

        
        const handleKeyDownUsuario = (event: any) => {

            const { key } = event

            if ((key === 'ArrowUp' || key === 'ArrowDown')) {
                event.preventDefault()

                let nextIndex
                if (key === 'ArrowUp') {
                    nextIndex = linhaSelecionadaUsuario === -1 || linhaSelecionadaUsuario === 0 ? usuarios.length - 1 : linhaSelecionadaUsuario - 1;
                } else {
                    nextIndex = linhaSelecionadaUsuario < usuarios.length - 1 ? linhaSelecionadaUsuario + 1 : 0;
                }

                const selectedItem = usuarios[nextIndex]
                console.log("selectedItem: ", selectedItem)

                if (selectedItem != undefined) {

                    //handleSetProdMove(selectedItem, nextIndex)
                    setLinhaSelecionadaUsuario(Math.max(0, Math.min(nextIndex, usuarios.length - 1)))

                    // Scroll into view
                    const element = document.getElementById(`produto-grade-${nextIndex}`)
                    if (element) {
                        element.scrollIntoView({
                            behavior: 'smooth',
                            block: 'nearest'
                        })
                    }

                } else {
                    setLinhaSelecionadaUsuario(-1)
                }
            }

        }
        
        const handleKeyPressEnterProduto = async (e: any) => {

            if ((e.code === "Enter" || e.code === "NumpadEnter")) {

                if (!loading && usuarios.length > 0) {
                    setNomeVendedor(nomeVendedorCopy)
                    setUsuarios([])
                    setLinhaSelecionadaUsuario(-1)

                } else {
                    await handleFilterClick()
                }
            }
        }
            

        //document.addEventListener('keydown', handleKeyDownUsuario)
        //document.addEventListener('keydown', handleKeyPressEnterProduto)

        return () => {
            //document.removeEventListener('keydown', handleKeyDownUsuario)
            //document.removeEventListener('keydown', handleKeyPressEnterProduto)
        }

    }, [linhaSelecionadaUsuario, usuarios, datai, dataf, relatorio, loading])
    */

    //------------------------------------------------------------------ PDF --------------------------------------------------------------------------------------------
    const handleGerarPDFClick = async () => {
        setVisible(false)

        try {
            const header = [
                { text: 'Venda', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
                { text: 'Valor Bruto', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
                { text: 'Valor Desconto', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
                { text: 'Valor Líquido', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
                { text: 'Nome  Cliente', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
                { text: 'Qtd.  Itens', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
                { text: 'Data', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
            ]

            const pdf = new ReportItensPeriodoPDF(relatorio, header, datai, dataf)
            pdf.GerarPDF(relatorio)

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage('Ocorreu um erro ao imprimir. Por favor, tente novamente')

        } finally {

            const timer = setTimeout(() => {
                InputFocus()
                clearTimeout(timer)
            }, 0)
        }
    }

    //----------------------------------------------------------------- FOCUS -------------------------------------------------------------------------------------------
    const handleTabPressNone = (event: any) => {

        if (event.key === 'Tab') {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleTabPressNone)

        return () => {

            document.removeEventListener('keydown', handleTabPressNone)
        }

    }, [])

    return (
        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div role='button' id="div-body" className={`${classDivBody}`}>

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`${classDivTitulo} flex flex-row mb-1`}>

                        <div className={`flex items-center w-full`}>
                            <TbReport className={`mr-2 ml-2 text-slate-700 dark:text-slate-200`} size="25px" />
                            <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200`}>Relatório de Itens - por período </span>
                        </div>

                    </div>

                    <div className={`w-auto h-auto rounded-md bg-white dark:bg-slate-600 border dark:border-slate-800 shadow-sm shadow-slate-400 dark:shadow-slate-800 cursor-default py-4`}>

                        <div className={`w-auto h-auto grid grid-cols-12 gap-4 px-3 py-3`}>

                            <div className={`relative col-span-12 sm:col-span-6 xl:col-span-2 mt-2 sm:mt-0`}>
                                <input id='data-inicial' className={`${classInput} ${classInputDark} ${datai === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark] `} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' value={datai} disabled={loading} onFocus={fecharLista} onChange={handleChangeDtInicio} />
                                <label htmlFor="data-inicial" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Data Período Inicial</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-6 xl:col-span-2 mt-2 sm:mt-0`}>
                                <input id='data-final' className={`${classInput} ${classInputDark} ${dataf === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark] `} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' value={dataf} disabled={loading} onFocus={fecharLista} onChange={handleChangeDtFim} />
                                <label htmlFor="data-final" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} `}>Data Período Final</label>
                            </div>

                            <div className={`relative col-span-12 xl:col-span-8 mt-2 sm:mt-0`}>

                                <div className={`flex w-full h-[45px] items-center`}>

                                    <div className={`relative w-full`}>

                                        <IoIosArrowDropdownCircle className={`absolute top-[10px] right-0 h-6 w-6 mx-2 text-slate-400 dark:text-slate-300 z-10 cursor-pointer`} onClick={abrirLista} />
                                        <input id='btPesquisaUsua' className={`${classInput} ${classInputDark} whitespace-nowrap text-left focus:cursor-pointer pr-7`} value={selectedItems.join(", ")} readOnly onClick={abrirLista} />
                                        <label htmlFor="btPesquisaUsua" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Vendedores</label>

                                        {visibleListaUsuario &&

                                            <div className={`absolute z-20 w-full min-h-[200px] max-h-[600px] overflow-y-auto bg-white dark:bg-slate-600 border border-slate-200 dark:border-slate-800 rounded-md`}>

                                                <div className={`h-[50px] w-full px-2 flex items-center border border-x-0 border-t-0 border-b-slate-300 dark:border-b-slate-800`}>

                                                    {!loadingPesq &&
                                                        <IoSearch className={`absolute h-4 w-4 mx-2 text-slate-400 dark:text-slate-300 z-10`} />
                                                    }
                                                    {loadingPesq &&

                                                        <div className={`z-10 absolute mx-2 inline-block h-4 w-4 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-blue-400 dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                            <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                                        </div>
                                                    }

                                                    <input id='pesquisaUsua' className={`${classInput} ${classInputDark} h-8 pl-8 mr-2 w-[80%] outline-none text-sm rounded-sm`} placeholder='Pesquisar Vendedores' disabled={loadingPesq} value={nomeVendedor} autoComplete='off' onChange={handleChangeNomeVendedor} />
                                                    <button id='btPesquisaUsua' className={`${classbtColunasAzul} h-8 w-[20%]`} onClick={buscarUsuario}>
                                                        Pesquisar
                                                    </button>
                                                </div>

                                                <div className={`w-full h-auto bg-red-50 dark:bg-[#475569] text-black dark:text-slate-200`}>

                                                    <ul id='elementos' className={`w-full`}>

                                                        {usuarios.map((item, index) => {
                                                            return (

                                                                <li key={item.id} id={`produto-grade-${index}`} className={`flex flex-row w-full h-auto hover:bg-slate-200 dark:hover:bg-slate-500 duration-150 transition-all border ${index === linhaSelecionadaUsuario ? ' border-slate-400 bg-slate-200 dark:bg-slate-500' : 'border-white dark:border-slate-600'} cursor-default`}>


                                                                    <div className={`flex items-center justify-center w-[10%] break-all border border-x-0 border-t-0 border-b-slate-300 dark:border-b-slate-800`}>
                                                                        <input
                                                                            type='checkbox'
                                                                            className={`accent-blue-500 h-5 w-5 outline-none cursor-pointer`}
                                                                            onChange={() => handleCheckBoxClick(item)}
                                                                            checked={selectedItemsID.includes(item.id)}
                                                                        />
                                                                    </div>

                                                                    <div className={`w-full flex flex-row h-[48px] font-mono border border-x-0 border-t-0 border-b-slate-300 dark:border-b-slate-800 `}>

                                                                        <div className={`flex items-center text-sm w-full break-all `}>
                                                                            <span className={`px-2`}>{item.description.trim()}</span>
                                                                        </div>

                                                                    </div>

                                                                </li>
                                                            )
                                                        })
                                                        }

                                                    </ul>

                                                </div>

                                                {loadingPesq &&

                                                    <div className={`absolute top-[50px] bottom-[0px] w-full pt-4 bg-white dark:bg-slate-600 bg-opacity-30 dark:bg-opacity-30 flex justify-center items-center`}>

                                                        <div className={`h-[60px] w-[60px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-cyan-600 dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                            <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                                        </div>

                                                    </div>
                                                }

                                            </div>
                                        }

                                    </div>

                                </div>

                            </div>

                            <div className={`col-span-12 flex flex-col sm:flex-row justify-end sm:space-x-2 mt-2 sm:mt-0`}>

                                <div className={`relative mt-2 sm:mt-0`}>
                                    <button tabIndex={-1} className={`${classBt} ${classbtCeuAzul} w-full sm:min-w-[150px] disabled:bg-opacity-50 disabled:cursor-not-allowed`} disabled={!(relatorio.length > 0)} onClick={handleGerarPDFClick}>
                                        <IoPrint size="20px" className={`hidden md:block mr-2`} />
                                        Imprimir
                                    </button>
                                </div>

                                <div className={`relative mt-6 sm:mt-0`}>
                                    <button className={`${classBtSemDuration} ${classbtCinzaClaro} w-full sm:min-w-[150px]`} onClick={limparCamposFiltro}>
                                        <AiOutlineClear size="20px" className={`mr-[2px]`} /><span className='mx-1'>Limpar Campos</span>
                                    </button>
                                </div>

                                <div className={`relative mt-6 sm:mt-0`}>
                                    <button tabIndex={-1} disabled={loading} className={`${loading ? `opacity-40` : ``} ${classbtColunasAzul} w-full sm:min-w-[150px]`} onClick={handleFilterClick} >
                                        <span className={`w-full h-full flex justify-center items-center`}>
                                            {!loading && <IoSearch size="20px" className={`hidden md:block mr-2`} />}
                                            {loading &&
                                                <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-[#2980b9] dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                    <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                                </div>
                                            }
                                            {!loading && `Pesquisar`} {loading && `Aguarde`}
                                        </span>
                                    </button>
                                </div>

                            </div>

                            <div className={`col-span-12`}>

                                <div className={`flex flex-col justify-start w-full h-auto border border-slate-500 rounded-md bg-gray-200 dark:bg-slate-700`}>

                                    <div className={`md:flex md:flex-row md:border md:border-x-0 md:border-t-0 md:border-slate-400 md:dark:border-slate-500 md:py-2`}>
                                        <div className={`w-full font-mono py-1 px-2 dark:text-slate-200 flex flex-row border md:border-none border-x-0 border-t-0 dark:border-slate-500 border-slate-400`}>
                                            <span className={`w-full md:w-auto`}>Valor Bruto: </span>
                                            <span className={`w-full md:w-auto flex justify-end items-center md:ml-2`}>{Funcoes.numberFormat(valorBruto, 'currency')}</span>
                                        </div>

                                        <div className={`w-full font-mono py-1 px-2 dark:text-slate-200 flex flex-row border md:border-none border-x-0 border-t-0 dark:border-slate-500 border-slate-400`}>
                                            <span className={`w-full md:w-auto`}>Valor Líquido: </span>
                                            <span className={`w-full md:w-auto flex justify-end items-center md:ml-2`}>{Funcoes.numberFormat(valorLiquido, 'currency')}</span>
                                        </div>
                                    </div>

                                    <div className={`md:flex md:flex-row md:py-2`}>

                                        <div className={`w-full font-mono py-1 px-2 dark:text-slate-200 flex flex-row border md:border-none border-x-0 border-t-0 dark:border-slate-500 border-slate-400`}>
                                            <span className={`w-full md:w-auto`}>Valor do Desconto: </span>
                                            <span className={`w-full md:w-auto flex justify-end items-center md:ml-2`}>{Funcoes.numberFormat(valorDesconto, 'currency')}</span>
                                        </div>

                                        <div className={`w-full font-mono py-1 px-2 dark:text-slate-200 flex flex-row`}>
                                            <span className={`w-full md:w-auto`}>Total de Vendas: </span>
                                            <span className={`w-full md:w-auto flex justify-end items-center md:ml-2`}>{totalRegistro}</span>
                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                    <div className={`w-full cursor-default mt-1 z-0 border shadow-sm shadow-slate-400 dark:bg-slate-600 dark:border-slate-800 dark:shadow-slate-800`}>
                        <GridRelPeriodoItens relItensPeriodo={relatorio} />
                    </div>

                </div>

            </div>

        </Template>
    )
}